import React, { useRef, useState } from 'react';
import cx from 'classnames';
import { debounce } from 'lodash';

import { DefaultFilledButton } from '@magoosh/lib/button';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { Pricing } from '@payments/types';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from '@payments/style.module.scss';

interface Props {
  couponCode: string;
  onApply: (couponCode: string) => Promise<any>;
}

const CouponCodeInput: React.FC<Props> = (props) => {
  const [isApplying, setIsApplying] = useState(false);
  const [localCouponCode, setLocalCouponCode] = useState(props.couponCode);

  const debouncedApply = useRef(
    debounce((value) => {
      setIsApplying(true);
      props.onApply(value).then(() => setIsApplying(false));
    }, 500)
  ).current;

  return (
    <div>
      <div className="form-group">

        <label className="control-label">
          Promo Code
        </label>

        <div className={style.mediumStringInput}>
          <div className="d-flex align-items-center input-group" style={{ gap: 10 }}>
            <div className="flex-1 flex-sm-none">
              <input
                className="form-control"
                name="couponCode"
                value={localCouponCode}
                onChange={(e) => {
                  setLocalCouponCode(e.target.value);
                  debouncedApply(e.target.value);
                }}
              />
            </div>

            {
              isApplying && (
                <div>
                  <FontAwesomeIcon icon="spinner" className="fa-pulse small text-gray-light" />
                </div>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default CouponCodeInput;
